import {type MediaCardType} from '@wandb/weave/common/types/media';

import {type FanOutVariable, type LayoutMode} from '../common';

export type CompareSyncInput = {
  gateOn: boolean;
  inReport: boolean;
  mode: LayoutMode | undefined;
  fanOutVariable: FanOutVariable | undefined;
  mediaType: MediaCardType | null;
};

export function isCompareEligible({
  gateOn,
  inReport,
  mode,
  mediaType,
}: Omit<CompareSyncInput, 'fanOutVariable'>) {
  return gateOn && !inReport && mode === 'compare' && mediaType === 'image';
}

export function isCompareSynced(input: CompareSyncInput) {
  return isCompareEligible(input) && input.fanOutVariable == null;
}
